/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Página no encontrada",
  "ComingSoon": "Próximamente",
  "YesanPersonalFinance": "Yesan, Finanzas personales",
  "Yesan": "Yesan",
  "PersonalFinance": "Finanzas Personales",
  "YesanDownload": "Yesan Descargar",
  "ThisWebsiteUsesCookies": "Utilizamos cookies para recopilar y analizar información sobre el rendimiento y el uso de nuestro sitio web, así como para ofrecer funciones de redes sociales. Si continúa navegando, consideramos que acepta su uso.",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Libérese financieramente",
  "inStepsAndActions": "en 8 pasos y 3 acciones.",
  "TrackPlanAnalyze": "Seguimiento. Planifique. Analizar.",
  "FTrack": "1. Rastrear",
  "FPlan": "2. Planificar",
  "FAnalyze": "3. Analizar",
  "Features": "Características",
  "FeaturesSubHeading": "Puro principiante, ya con conocimientos financieros, esta es la aplicación que necesitas para liberarte financieramente.",
  "ManageAccounts": "Gestionar Cuentas",
  "CashLiquidFixedAssetsLiabilities": "Efectivo, Líquido, Activos Fijos y Pasivos.",
  "TrackTransactions": "Seguimiento de Transacciones",
  "IncomesExpensesTransferInvestments": "Ingresos, Gastos, Transferencias, Inversiones.",
  "ImportExport": "Importar / Exportar",
  "YourDataAlwaysAccessible": "Tus datos siempre accesibles.",
  "PlanYourFreedom": "Planifica tu libertad",
  "StepsAwayFromFI": "A 8 pasos de la Independencia Financiera.",
  "BudgetsAndGoals": "Presupuestos y Objetivos",
  "CheckYourProgressAndAchieve": "Compruebe su progreso y alcance sus objetivos financieros.",
  "DashboardAndAnalytics": "Cuadro de mandos y análisis",
  "ReviewLearnOptimizeWith": "Revise, aprenda y optimice con gráficos, perspectivas y herramientas.",
  "Security": "Seguridad",
  "MilitaryGradeEncryption": "Cifrado de grado militar, soporte de biometría, datos almacenados en sus dispositivos.",
  "OfflineMode": "Modo Offline",
  "YourDataAlwaysAccessibleAndModif": "Tus datos siempre accesibles y modificables.",
  "Track": "Seguimiento",
  "Income": "Ingresos",
  "Expense": "Gastos",
  "Transfer": "Transferencia",
  "transactionsAndManageAccounts": "transacciones y gestionar diversas Cuentas",
  "checkings": "Cuenta corriente",
  "savings": "Ahorro",
  "realEstate": "Bienes inmuebles",
  "stocks": "Bolsa",
  "bonds": "Bonos",
  "crypto": "Cripto",
  "notes": "Billetes, Monedero",
  "envelopes": "Sobres",
  "privateEquity": "Capital privado",
  "metal": "Metal",
  "retirement": "Jubilación",
  "lifeInsurance": "Seguros de vida",
  "intellectualProperty": "Propiedad intelectual",
  "otherLiquidAsset": "Otros activos líquidos",
  "otherFixedAsset": "Otro activo fijo",
  "mortgage": "Hipoteca",
  "loan": "Préstamo al consumo",
  "creditCard": "Tarjeta de crédito",
  "otherLiability": "Otro pasivo",
  "AccountsManagement": "Gestión de cuentas",
  "MultipleAccountsTypesAndGrouping": "Agrupación y tipos de cuentas múltiples",
  "LinkAccounts": "Vincular cuentas de sus instituciones (disponible sólo en algunos países)",
  "SmartAccounts": "Cuentas inteligentes",
  "AddEditDeleteTransactions": "Añadir / Editar / Eliminar transacciones",
  "TickVerifiedTransactions": "Marcar transacciones verificadas",
  "CategorizeTransactions": "Categorizar transacciones",
  "TagTransactions": "Etiquetar transacciones",
  "TrackKakeiboType": "Seguimiento de tipo Kakeibo",
  "TrackInvestments": "Seguimiento de inversiones (disponible sólo en algunos países)",
  "ImportFromCSVFile": "Importe transacciones completas o incrementales desde un archivo CSV",
  "ExportToCSVFile": "Exporte transacciones a un archivo CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "Plan de 8 pasos hacia la Independencia Financiera, presupuesto detallado, alcance sus metas financieras más rápido.",
  "levelsTowardsFI": "8 niveles hacia la Independencia Financiera",
  "EstablishBudgetsPer": "Establezca presupuestos por",
  "account": "cuenta",
  "accountType": "tipo de cuenta",
  "KakeiboType": "Tipo de Kakeibo",
  "category": "categoría",
  "tag": "etiqueta",
  "label": "etiqueta",
  "TrackBudgetsPerFrequency": "Seguimiento de presupuestos por frecuencia",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Crear objetivos de gasto, saldo, flujo de caja y acciones",
  "TrackGoalsProgress": "Seguimiento del progreso de los objetivos",
  "ReviewLearnOptimizeWithReportsCharts": "Revise, aprenda y optimice con informes, gráficos, tendencias, perspectivas y herramientas.",
  "Dashboard": "Panel de control",
  "FSNetWorth": "Estados financieros: Patrimonio neto",
  "FSPnL": "Estados Financieros: Cuenta de resultados",
  "FSBalanceSheetAssetsLiabilities": "Estados Financieros: Balance, Activo, Pasivo",
  "FSCashFlow": "Estados Financieros: Estado de Flujo de Caja, Débito Crédito, Flujos",
  "FSFlows": "Estados Financieros: Flujos",
  "FSRatios": "Estados Financieros: Ratios",
  "TrendsMonthEnd": "Tendencias de Fin de Mes: Ingresos y Gastos, Flujo de Caja",
  "TrendsPerformance": "Tendencias de rendimiento: YoY, MoM, WoW",
  "IncomeTrendsPer": "Tendencias de ingresos por",
  "SpendingTrendsPer": "Tendencias de gasto por",
  "RecurringItemsIE": "Partidas recurrentes: Ingresos y gastos",
  "DebtProgressTrends": "Evolución de la deuda",
  "KakeiboMTDReviewTrends": "Kakeibo: Revisión MTD, último mes, tendencias",
  "FIWCLE": "Independencia Financiera: Gráfico mural, gastos por energía vital",
  "DebtPaydownSnowballAvalanche": "Pago de deudas: Bola de nieve, Avalancha",
  "FullyCustomizableAnalyticsRange": "Rango temporal de análisis totalmente personalizable",
  "ContactUs": "Contacte con nosotros",
  "Privacy": "Privacidad",
  "Terms": "Términos",
  "About": "Acerca de",
  "IAgreeToThe": "Estoy de acuerdo con el",
  "AndThe": "y la",
  "PrivacyPolicy": "Política de privacidad",
  "TermsOfUse": "Condiciones de uso",
  "DigitalSoftwareExperienceTagline": "Experiencia digital de software para el mundo moderno",
  "DigitalExperience": "Experiencia digital",
  "SoftwareForTheModernWorld": "Software para el mundo moderno",
  "MobileApplications": "Aplicaciones móviles",
  "forConnectedAndOfflineHumans": "para humanos conectados y desconectados",
  "CloudSaaS": "SaaS en la nube",
  "ResponsiveAndWebServices": "Responsive y servicios web",
  "PersonalFinanceServices": "Servicios de finanzas personales",
  "YS_p1": "Yesan es una empresa de software dinámica especializada en el desarrollo de aplicaciones móviles de vanguardia adaptadas a los consumidores. Con un profundo conocimiento de la evolución de las necesidades y preferencias de los usuarios expertos en tecnología de hoy en día, Yesan se dedica a la elaboración de experiencias móviles intuitivas, atractivas y ricas en características que enriquecen la vida de sus usuarios.",
  "YS_p2": "En el núcleo de la misión de Yesan se encuentra un compromiso implacable con la innovación y la creatividad, cada producto está meticulosamente diseñado para ofrecer una funcionalidad perfecta y una experiencia de usuario excepcional.",
  "PersonalFinanceApplication": "Aplicación de finanzas personales",
  "YPF_p1": "Yesan, Finanzas Personales es una aplicación móvil de finanzas personales de vanguardia diseñada para capacitar a los usuarios con herramientas integrales de gestión financiera convenientemente accesibles a su alcance. Con una interfaz elegante e intuitiva, Yesan, Finanzas Personales ofrece un enfoque holístico para la gestión de las finanzas, atendiendo a los usuarios de todos los niveles de conocimientos financieros.",
  "YPF_p2": "Entre sus principales funciones se incluyen el seguimiento de presupuestos, la categorización de gastos y la supervisión de transacciones en tiempo real, lo que permite a los usuarios conocer sus hábitos de gasto sin esfuerzo. La aplicación también ofrece opciones personalizables de elaboración de presupuestos, lo que permite a los usuarios establecer objetivos financieros y realizar un seguimiento de su progreso a lo largo del tiempo.",
  "YPF_p3": "Además, Yesan, Finanzas Personales prioriza la seguridad, empleando protocolos de encriptación de última generación para salvaguardar la información financiera confidencial de los usuarios. Con medidas de seguridad de nivel bancario, los usuarios pueden vincular con confianza sus cuentas y sincronizar las transacciones sin comprometer la privacidad.",
  "YPF_p4": "Yesan, Finanzas Personales va más allá de la presupuestación básica al ofrecer análisis perspicaces y recomendaciones personalizadas para optimizar las decisiones financieras. Tanto si se trata de identificar posibles oportunidades de ahorro, supervisar carteras de inversión o gestionar estrategias de pago de deudas, la aplicación proporciona información personalizada para ayudar a los usuarios a alcanzar sus objetivos financieros.",
  "Discover": "Descubra",
  "Firstname": "Nombre",
  "Lastname": "Apellido",
  "Company":"Empresa",
  "Subject": "Asunto",
  "Email": "Correo electrónico",
  "Message": "Mensaje",
  "ThankYouForContactingUs": "Gracias por ponerse en contacto con nosotros",
  "ValidFirstnameRequired": "Se requiere un nombre válido.",
  "ValidLastnameRequired": "Apellido válido es obligatorio.",
  "ValidEmailAddressRequired": "Introduzca una dirección de correo electrónico válida.",
  "ValidSubjectRequired": "Seleccione un asunto válido.",
  "ValidMessageRequired": "Introduzca un mensaje válido.",
  "UnableToSendTheFormPleaseRetryLater": "No se ha podido enviar el formulario, vuelva a intentarlo más tarde.",
  "Information": "Información",
  "Sales":"Ventas",
  "Support": "Soporte",
  "Press": "Prensa",
  "Partnership": "Asociación",
  "Other": "Otros",
  "Blog":"Blog",

  "Accept":"Aceptar",
  "Decline":"Rechazar",

  "WorklogCalendar":"Worklog Calendar para Jira",

  "DirectlyAccessibleInProjectApps":"Acceso directo en las aplicaciones del proyecto",
  "VisualizeWhereYouSpentYourTime":"Visualice en qué ha empleado su tiempo",
  "AllYourWorklogsInACalendar":"Todos tus worklogs en un calendario",
  "MonthSummary":"Resumen mensual",
  "CheckIfYouForgotToLogTime":"Compruebe si ha olvidado registrar el tiempo",
  "DirectlyAccessTheIssuesAndUpdateTime":"Acceda directamente a las incidencias y actualice el tiempo",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Haga clic en el elemento del registro de trabajo para acceder directamente a las incidencias y editar el tiempo registrado",
  "AlsoAvailableInDarkMode":"También disponible en modo oscuro",
  "DirectlyLogWorkOnTheCalendarVisually":"Registrar directamente el trabajo en el calendario de forma visual",
  "ClickOnTheCalendarToCreateNewWorklog":"Haga clic en el calendario para crear un nuevo registro de trabajo",

  "AppsForAtlassian":"Aplicaciones para Atlassian",
  "YCL_p1":"Visualiza todos tus worklogs en un calendario con vistas de mes, semana, semana laboral, día.",
  "YCL_p2":"Registre el trabajo directamente desde el calendario seleccionando visualmente la franja horaria.",
  "YCL_p3":"Identifique si olvidó registrar el tiempo para sus hojas de horas.",
  "YCL_p4":"Disponible en su idioma: Inglés (UK), Inglés (US), Chino (Simplificado), Chino (Tradicional), Checo, Danés, Holandés, Estonio, Finlandés, Francés, Alemán, Húngaro, Islandés, Italiano, Japonés, Coreano, Noruego, Polaco, Portugués (Brasil), Portugués (Portugal), Ruso, Español, Sueco, Turco.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Cartera financiera para Jira",
  "BringRealFinancialPortfolio":"Incorpora una gestión real de la cartera financiera a Jira. Realiza un seguimiento de los presupuestos, los gastos de capital (CapEx) y los gastos operativos (OpEx), así como de los costes de los proyectos, todo en un mismo lugar.",
  "YFPAboutQ":"¿Cuánto nos cuestan realmente nuestros proyectos de Jira?",
  "YFPAbout":"Cartera financiera para Jira\nLos responsables financieros y las oficinas de gestión de proyectos (PMO) tienen dificultades para responder a una pregunta sencilla:\n¿Cuánto nos cuestan realmente nuestros proyectos de Jira?\nJira realiza un seguimiento del trabajo.\nEl departamento financiero realiza un seguimiento de los presupuestos.\nEsta aplicación conecta por fin ambos aspectos.\n\nCartera financiera convierte Jira en una plataforma ligera de gestión de proyectos y planificación financiera, sin necesidad de costosas herramientas empresariales.",
  "YFPPorfolioQ":"Presupuestos y seguimiento de carteras",
  "YFPPorfolioP":"Crea carteras que abarquen varios proyectos de Jira y define: importe del presupuesto, moneda, intervalo de fechas, proyectos incluidos y equipos. Realiza un seguimiento automático de los costes reales a medida que se desarrolla el trabajo en Jira.",
  "YFPPorfolioListQ":"Carteras",
  "YFPPorfolioListP":"Crea carteras financieras que combinen múltiples proyectos de Jira y visualiza al instante: presupuesto frente a coste real, tasa de consumo del proyecto en tiempo real, desglose de CapEx frente a OpEx, coste por incidencia y proyecto, informes financieros exportables. Todo ello alimentado directamente por los registros de trabajo de Jira.",
  "CostQ":"Cálculo automático de costes",
  "CostP":"Convierte el seguimiento del tiempo en datos financieros reales. La aplicación: lee los registros de trabajo de Jira, aplica tarifas por hora, calcula los costes reales del proyecto a diario. Sin hojas de cálculo. Sin trabajo manual.",
  "RatesQ":"Tarifas",
  "RatesP":"Establece la tarifa por hora por proyecto, equipo o de forma global",
  "ReportQ":"Informes financieros en CSV",
  "ReportP":"Exporta datos financieros de la cartera en segundos. Perfecto para: equipos financieros, informes del director financiero, planificación presupuestaria, apoyo a auditorías",
  "SettingsQ":"Clasificación CapEx vs OpEx",
  "SettingsP":"Cumple con los requisitos contables y de auditoría. Clasifica el trabajo en: desarrollo capitalizable (CapEx), trabajo operativo (OpEx). Genera informes exportables listos para los equipos financieros."
};

export const documents = {
};
